import { ChevronRightIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { useLocale } from '@/hooks';
import { BUILD_PRO_FEATURE_COACHMARK_CONFIG, resolveCoachmarkLocale } from './buildProFeatureCoachmark.config';
import { useBuildProFeatureCoachmarkContext } from './BuildProFeatureCoachmarkProvider';
import { CoachmarkBubble } from './CoachmarkBubble';
import { type BuildProFeatureCoachmarkFeature } from './types';
export const BuildProFeatureCoachmarkContent = ({
  feature,
  activeStep,
  totalSteps
}: {
  feature: BuildProFeatureCoachmarkFeature;
  activeStep: number;
  totalSteps: number;
}) => {
  const {
    close,
    next,
    previous
  } = useBuildProFeatureCoachmarkContext();
  const {
    t
  } = useTranslation(['build', 'common']);
  const {
    locale
  } = useLocale();
  const config = BUILD_PRO_FEATURE_COACHMARK_CONFIG[feature];
  const isLastStep = activeStep >= totalSteps;
  const isFirstStep = activeStep <= 1;
  return <CoachmarkBubble imageSrc={`/assets/ai-tutor/coachmark/${config.imageName}-${resolveCoachmarkLocale(locale)}.webp`} description={t(config.descriptionKey)} closeAriaLabel={t('build:coachmark.closeAriaLabel')} backAriaLabel={t('build:coachmark.backAriaLabel')} showBack={!isFirstStep} onBack={previous} stepLabel={`${activeStep}/${totalSteps}`} primaryLabel={isLastStep ? t('build:coachmark.finishButton') : t('common:global.next.button')} primaryRightIcon={!isLastStep ? <ChevronRightIcon size="xs" /> : undefined} onPrimaryClick={next} onClose={close} data-sentry-element="CoachmarkBubble" data-sentry-component="BuildProFeatureCoachmarkContent" data-sentry-source-file="BuildProFeatureCoachmarkContent.tsx" />;
};